import { MutableRefObject, useEffect } from 'react';

export const useClickOutside = (
  ref: MutableRefObject<HTMLDivElement | undefined | null>,
  onClickOutside: () => void,
  excludeRef?: MutableRefObject<HTMLDivElement | undefined | null>
) => {
  useEffect(() => {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    function handleClickOutside(event: any) {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !(excludeRef?.current?.contains(event.target) ?? false) &&
        !document.getElementById('toast-bottom-right')?.contains(event.target)
      ) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickOutside, excludeRef]);
};
